import * as React from 'react'
import { SVGProps } from 'react'

export const HeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 473.13" {...props}>
    <use href="#heart-filled" />
  </svg>
)
